(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

// Constructor

var BackTop = function BackTop() {
    // Add the back to top button
    $('body').append('<a id="return-to-top"><span class="icon-arrow-up"></span><span>Top</span></a>');

    // Click show hide and click action
    $(window).scroll(function () {
        if ($(this).scrollTop() >= 100) {
            // If page is scrolled more than 100px
            $('#return-to-top').addClass('show'); // Fade in the arrow
        } else {
            $('#return-to-top').removeClass('show'); // Else fade out the arrow
        }
    });
    $('#return-to-top').click(function () {
        // When arrow is clicked
        $('body,html').animate({
            scrollTop: 0 // Scroll to top of body
        }, 1000);
    });

    // When window resize recompute back top position
    $(window).resize(function () {
        backTopPosition();
    });

    backTopPosition();
};

module.exports = BackTop;

function backTopPosition() {
    if (window.innerWidth > 1440) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width() + 60;
        $('#return-to-top').css('left', left);
    } else if (window.innerWidth < 1350) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width() - 60;
        $('#return-to-top').css('left', left);
    } else if (window.innerWidth > 1024) {
        var $pageContainer = $('.o-pageHead + .a-pageContainer');
        var left = $pageContainer.offset().left + $pageContainer.width();
        $('#return-to-top').css('left', left);
    }
}

},{}],2:[function(require,module,exports){
"use strict";

// 'use strict';


var Banner = function Banner() {};
module.exports = Banner;

},{}],3:[function(require,module,exports){
'use strict';

// Constructor

var Header = function Header() {
    $(".page-node-type-book-cover header").append("<div class='mobile-menu-click'> <h2>Contents</h2> </div>");
    $('.page-node-type-book-cover header .a-aspiLogo').append("<h2 class='desktop'>Australian Strategic Policy Institute</h2>");
    $('.page-node-type-book-cover header .a-aspiLogo').append("<h2 class='mobile'>aspi</h2>");
};

module.exports = Header;

},{}],4:[function(require,module,exports){
'use strict';

window.$ = jQuery;

var Program = require('./program.link/program.link');
var Navigation = require('./navigation/navigation');
var Header = require('./header/header');
var Banner = require('./banner/banner');
var BackTop = require('./back.top/top');

$(function () {
    new Program();
    new Navigation();
    new Header();
    new Banner();
    new BackTop();
});

},{"./back.top/top":1,"./banner/banner":2,"./header/header":3,"./navigation/navigation":5,"./program.link/program.link":6}],5:[function(require,module,exports){
'use strict';

var Navigation = function Navigation() {
	$(function () {
		$('.book-depth-1 li').each(function (i, v) {
			var $this = $(v),
			    hasSecondLevel = $this.find('.book-depth-2').length;

			if (!hasSecondLevel) {
				$this.find('.book-depth-1-accordion').remove();
			};
		});

		$('.book-depth-1-accordion').on('click', function (e) {
			var $this = $(this),
			    $parent = $this.parent();

			$this.toggleClass("close");
			$parent.find('.book-depth-2').toggleClass('book-depth-2-active');
		});
	});

	$(function () {
		$('.book-depth-1 li').each(function (i, v) {
			var $this = $(v),
			    hasSecondLevel = $this.find('.book-depth-2').length;

			if (hasSecondLevel) {
				console.log("YAS1");

				if ($this.find('a').hasClass("is-active")) {
					console.log("YAS2");
					$(".is-active").closest(".book-depth-2").addClass("book-depth-2-active");
					$(".book-depth-2-active").siblings("span").addClass("close");
					// $(".book-depth-1-accordion").addClass("close");
				}
				// $this.find('.is-active').parent().addClasslass("book-depth-2-active");
			};
		});
	});

	$(function () {
		$('.book-depth-1 li').each(function (i, v) {
			var $this = $(v);

			if ($this.find('a').hasClass("is-active")) {

				// $this.find("")
				$(".is-active").next('.book-depth-2').addClass("book-depth-2-active");
				$(".book-depth-2-active").siblings("span").addClass("close");
			}
		});
	});
	$(function () {
		$(".mobile-menu-click").on('click', function (e) {
			e.preventDefault();
			var $this = $(this),
			    $parent = $this.parent();

			$this.toggleClass("active");

			if ($(".aspi-book-side-navigation").hasClass('aspi-book-side-navigation-active')) {
				$(".aspi-book-side-navigation").removeClass("aspi-book-side-navigation-active");
			} else {
				$(".aspi-book-side-navigation").addClass("aspi-book-side-navigation-active");
			}
		});
	});

	$(function () {
		$(".aspi-book-side-navigation").prepend("<div class='aspi-book-side-navigation-headers'> </div>");
		$("header .o-pageHead__share").clone().prependTo(".aspi-book-side-navigation-headers");
		$(".block-aspi-book-program-logo").clone().prependTo(".aspi-book-side-navigation-headers");
	});
};

module.exports = Navigation;

},{}],6:[function(require,module,exports){
"use strict";

var Program = function Program() {
    $(document).ready(function () {
        $(".media.img").wrap($(".field-content"));
    });
};

module.exports = Program;

},{}],7:[function(require,module,exports){
'use strict';

var _main = require('book.template/main.js');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {

  (0, _main2.default)();

  $('html').addClass('book-js-loaded');
});

},{"book.template/main.js":4}]},{},[7])

